import React, { memo, useMemo } from "react";

// interfaces
import { SavingTextProps } from "@payment-ui/components/tick-screen/interfaces";
import { TICK_STATES } from "@payment-ui/components/tick-screen/constants";
import { OFFER_TAG, TICK_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getSavingsText } from "@payment-ui/components/tick-screen/helpers";

// components
import { Container, FlexGrow, IconWrapper, Savings, SavingsWrapper } from "./styles";
import SavingsIcon from "./SavingsIcon";

function SavingText({ savings, tickState, isFreeDel, isMilestoneUnlockEligible, isToingFlow }: SavingTextProps) {
    const savingsText = useMemo(() => getSavingsText(savings, isMilestoneUnlockEligible), [
        savings,
        isMilestoneUnlockEligible,
    ]);

    // Don't show savings text if savings is empty or tickState is not success
    if (isEmpty(savings) || tickState !== TICK_STATES.SUCCESS) {
        return null;
    }

    if (isEmpty(savings.successMessage) && isEmpty(savings.successMessageInfo) && !isMilestoneUnlockEligible) {
        return null;
    }

    return (
        <Container data-testid={OFFER_TAG.CONTAINER}>
            <SavingsWrapper
                data-testid={TICK_SCREEN_TEST_IDS.SAVINGS_TEXT}
                isFreeDel={isFreeDel}
                isToingFlow={isToingFlow}
            >
                <FlexGrow />
                <IconWrapper>
                    <SavingsIcon isToingFlow={isToingFlow} isFreeDel={isFreeDel} />
                </IconWrapper>

                <Savings
                    variant={"V2.body3.neutral.regular"}
                    color={isFreeDel ? "rain" : "positive"}
                    maxLines={2}
                    textAlign="left"
                >
                    {savingsText}
                </Savings>
                <FlexGrow />
            </SavingsWrapper>
        </Container>
    );
}

export default memo(SavingText);
